import React, { useState, useEffect, useMemo, useContext, useCallback } from 'react'
import { useTranslation } from "react-i18next"
import { Dialog, Typography } from '@material-ui/core'
import _ from 'lodash'
import Autocomplete from '@mui/material/Autocomplete'
import TextField from '@material-ui/core/TextField'
import IconButton from '@material-ui/core/IconButton'
import Slider from '@material-ui/core/Slider'
import { withStyles, makeStyles } from '@material-ui/core/styles'
import CloseIcon from '@material-ui/icons/Close'
import Checkbox from '@material-ui/core/Checkbox'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Tooltip from "@material-ui/core/Tooltip"
import HelpIcon from "@material-ui/icons/Help"
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import TreeView from '@material-ui/lab/TreeView'
import TreeItem from '@material-ui/lab/TreeItem'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import ChevronRightIcon from '@material-ui/icons/ChevronRight'
import SearchIcon from '@material-ui/icons/Search'
import InputAdornment from '@material-ui/core/InputAdornment'
import Paper from '@material-ui/core/Paper'
import Button from '@material-ui/core/Button'
import {
  DialogTitle,
  DialogContent,
  DialogActions
} from '@mui/material'


import { GetAlertsComponent, setObjectByPath} from "./utils"
import RulesContext from "../../../../context/rules-context"
import SCRModalityOptions from './Assets/SCRModalityOptions.json'
import { trimNestedObject } from '../../../Utils/utils'

const domainTypeOptions = [
    { label: "Todos", steps: [] },
    { label: "Limite de crédito", steps: [20, 40], rangeSectionTitle: "Tempo até o vencimento"},
    { label: "Créditos a liberar", steps: [60, 80] , rangeSectionTitle: "Tempo até a liberação"},
    { label: "Créditos a vencer", steps: [110, 120, 130, 140, 150, 160, 165, 170, 175, 180, 190], rangeSectionTitle: "Tempo até o vencimento", nonExpiringDomain: 199},
    { label: "Créditos vencidos", steps: [205, 210, 220, 230, 240, 245, 250, 255, 260, 270, 280, 290], rangeSectionTitle: "Tempo desde o vencimento"},
    { label: "Créditos baixados como prejuízo", steps: [310, 320, 330], rangeSectionTitle: "Tempo desde a baixa" },
]

const stepToDaysMap = {
    // Limite de crédito
    20: "0",
    40: "360",

    // Créitos a liberar
    60: "0",
    80: "360",

    // Créitos a vencer (The big list)
    110: "0",
    120: "30",
    130: "60",
    140: "90",
    150: "180",
    160: "360",
    165: "720",
    170: "1080",
    175: "1440",
    180: "1800",
    190: "5400",

    // Créitos vencidos
    205: "0",
    210: "14",
    220: "30",
    230: "60",
    240: "90",
    245: "120",
    250: "150",
    255: "180",
    260: "240",
    270: "300",
    280: "360",
    290: "540",

    // Prejuízo (Months)
    310: "0",
    320: "12",
    330: "48",

    "inf": "∞"
}


const DarkTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: 'rgba(27, 27, 27, 0.94)',
    color: '#ffffff',
    fontSize: 12,
    borderRadius: 4,
    padding: '6px 12px',
    maxWidth: 'none',
    textAlign: 'center',
    marginTop: 10,
  },
  arrow: {
    display: 'none',
  }
}))(Tooltip)

const useSliderStyles = makeStyles({
  root: {
    height: 4,
    padding: '13px 0',
    marginTop: 25,
    marginBottom: 20,
  },
  markLabel: {
    top: -25,
    fontSize: '0.75rem',
  },
})

function ValueLabelComponent(props) {
  const { children, open, value } = props

  return (
    <DarkTooltip
      open={open}
      enterTouchDelay={0}
      placement="bottom"
      title={value}
    >
      {children}
    </DarkTooltip>
  )
}

const flattenModalities = (modalityObject) => {
    if (!modalityObject || _.isEmpty(modalityObject)) return []
    return Object.entries(modalityObject).reduce((idList, [parentCode, childCodes]) => {
        const uniqueIds = childCodes.map(childCode => `${parentCode}${childCode}`)
        return idList.concat(uniqueIds)
    }, [])
}

const groupModalities = (flatArray) => {
    return flatArray.reduce((modalitiesObject, uniqueId) => {
        if (uniqueId.length < 4) return modalitiesObject

        const parentCode = uniqueId.substring(0, 2)
        const childCode = uniqueId.substring(2)

        if (!modalitiesObject[parentCode]) {
            modalitiesObject[parentCode] = []
        }
        modalitiesObject[parentCode].push(childCode)
        return modalitiesObject
    }, {})
}

const getAllIds = (dataset) => {
    return dataset.reduce((idList, modality) => {
        const parentId = modality.value
        const children = modality.submodalities || []
        const childIds = children.map(c => `${parentId}${c.value}`)
        return idList.concat(childIds)
    }, [])
}

export function SCRBox (props) {
    const { t } = useTranslation()
    let {node} = props
    let {read_only} = props
    let {handleConfigurationOpen} = props
    let {handleNodeRemove} = props

    return (
        <div>
            {!read_only ?
                <div style={{display:"flex", alignItems: "center"}}>
                    <div style={{display:"flex", width:"100%", cursor:"pointer", margin: "auto 0px"}} onClick={() => handleConfigurationOpen(node)}>
                        {t("SCR")}
                        {(node.node.alerts || []).length > 0?
                        <GetAlertsComponent alerts={node.node.alerts} />  : null} </div>
                    <IconButton style={{width: 32, height: 32}} aria-label="duplicate" onClick={() => props.handleNodeDuplication(node)}>
                        <ContentCopyIcon style={{width: 20, height: 20}} />
                    </IconButton>
                    <IconButton style={{width: 32, height: 32}} aria-label="close" onClick={() => handleNodeRemove(node)}>
                        <CloseIcon style={{width: 20, height: 20}} />
                    </IconButton>
                </div>
                :
                <div style={{display:"flex"}}>
                    <div style={{display:"flex", width:"100%", cursor:"pointer", margin: "auto 0px"}} onClick={() => handleConfigurationOpen(node)}>
                        {t("SCR")}
                    </div>
                </div>
            }
        </div>
    )
}


export function SCRConfiguration(props){
    const { t } = useTranslation()
    let { read_only } = props
    let { handleConfigurationClose } = props
    let { handleNodeChange } = props
    let { node } = props

    const [open, setOpen] = useState(true)
    const [nodeState, setNodeState] = useState(node)
    const [errorState, setErrorState] = useState({})
    const [confirmExitOpen, setConfirmExitOpen] = useState(false)

    const hasErrors = Object.keys(errorState).length > 0

    useEffect(() => {
        setNodeState(node)
    }, [node])

    const handleClose = () => {
        handleConfigurationClose()
        setOpen(false)
    }

    const handleAttemptClose = () => {
        if (read_only) {
            handleClose()
        } else {
            setConfirmExitOpen(true)
        }
    }

    const handleChange = useCallback((field, newValue) => {
        const fieldsToCheck = Array.isArray(field) ? field : [field]
        setErrorState(prevErrors => {
            const hasError = fieldsToCheck.some(f => prevErrors[f])
            if (!hasError) return prevErrors
            const newErrors = { ...prevErrors }
            fieldsToCheck.forEach(f => delete newErrors[f])
            return newErrors
        })

        setNodeState(prevNodeState => {
            const isFieldArray = Array.isArray(field)
            const isValueArray = Array.isArray(newValue)

            if (isFieldArray !== isValueArray || (isFieldArray && field.length !== newValue.length)) {
                console.error("Field and newValue must both be arrays of the same length or both be non-arrays.")
                return prevNodeState
            }

            const fields = isFieldArray ? field : [field]
            const values = isValueArray ? newValue : [newValue]
            let new_node = _.cloneDeep(prevNodeState)

            fields.forEach((f, index) => {
                setObjectByPath(
                    new_node.node,
                    `properties.${f}`,
                    values[index]
                )
            })
            return new_node
        })
    }, [])

    const validateForm = () => {
        const errors = {}
        const props = nodeState.node.properties

        if(!props?.multiple_dates_bases_strategy) {
            errors["multiple_dates_bases_strategy"] = {
                message: "Selecione uma ação para múltiplas Datas-Bases"
            }
        }

        if(props?.multiple_dates_bases_strategy === "offset_match" && typeof props?.target_offset !== "number") {
            errors["target_offset"] = {
                message: "Selecione uma data-base"
            }
        }

        return errors
    }

    const handleSave = () => {
        const errors = validateForm()
        if(Object.keys(errors).length > 0) {
            setErrorState(errors)
            return
        }
        const trimmedProperties = trimNestedObject(_.cloneDeep(nodeState.node.properties))
        handleNodeChange({...nodeState, node: {...nodeState.node, properties: trimmedProperties}})
        handleClose()
    }

    return(
        <>
        <Dialog
        open={open}
        onClose={handleAttemptClose}
        fullWidth
        maxWidth="sm"
        PaperProps={{style:{padding: "20px 25px"}}}
        >
            <div style={{display: "flex", marginBottom:"12px", justifyContent: "space-between"}}>
                <span className={["blueText", "titleSize"].join(" ")}>{t("Consulta SCR Personalizada")}</span>
                <Tooltip title={<div className="tooltipText"><ul>{node.node.helperText.map((help,index) => (<li key={index}>{t(help)}</li>))}</ul></div>}>
                    <HelpIcon style={{fontSize: "16px", marginTop:"5px"}}/>
                </Tooltip>
            </div>
            <div style={{display:"flex", flexDirection: "column"}}>
                <SelectMultipleBaseDatesOption
                    readOnly={read_only}
                    nodeState={nodeState}
                    handleChange={handleChange}
                    errorState={errorState}
                />
                <span className={["blueText", "dialogInfoSize"].join(" ")} style={{marginTop: "10px"}} >{t("Detalhes da Consulta")}</span>
                <ConsultationDetails
                    readOnly={read_only}
                    nodeState={nodeState}
                    handleChange={handleChange}
                 />
            </div>
            <div style={{display:"flex", margin: "12px auto 0 auto"}}>
                <div
                    className={["button", "onlyboarder", "normalText", "normalMediumSize"].join(" ")}
                    style={{width:"120px"}}
                    onClick={handleClose}
                >
                    {read_only ? "X" : t("discard")}
                </div>
                {!read_only && <Tooltip
                    title={hasErrors? <div className="tooltipText"><ul>{Object.entries(errorState).map(([key, error], index) => (<li key={index}>{t(error?.message || "")}</li>))}</ul></div>: ""}
                >
                    <div
                        className={["button", "standard", "normalText", "normalMediumSize", hasErrors ? "disabled" : "" ].join(" ")}
                        style={{ width: "120px" }}
                        onClick={hasErrors ? null : handleSave}
                    >
                        {t("save")}
                    </div>
                </Tooltip>}
            </div>
        </Dialog>
        {confirmExitOpen && <Dialog
            open={confirmExitOpen}
            onClose={() => setConfirmExitOpen(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                {t("Tem certeza que deseja fechar?")}
            </DialogTitle>
            <DialogContent>
                <Typography id="alert-dialog-description">
                    {t("Você perderá os dados novos/alterados. Deseja continuar?")}
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => setConfirmExitOpen(false)}
                        className="button onlyboarder normalText normalMediumSize">
                    {t("Não, continuar editando")}
                </Button>
                <Button onClick={handleClose}
                        className="button standard normalText normalMediumSize">
                    {t("Sim, fechar")}
                </Button>
            </DialogActions>
        </Dialog>}
        </>
    )
}

function SelectMultipleBaseDatesOption(props){
    const { t } = useTranslation()

    const { readOnly } = props
    const { handleChange } = props
    const { nodeState } = props
    const { errorState } = props

    const processorsVariables = useContext(RulesContext).processors_variables
    const baseDatesOptions = useMemo(() => processorsVariables.filter(variable => variable.path.match(/enricher_credit_information_system\._M\d+/)).map(variable => ({
        label: variable.path.split('.')[1].substring(1),
        value: parseInt(variable.path.split('.')[1].slice(2))
    })), [processorsVariables])

    const multipleBaseDatesOptions = useMemo(() => {
        let options =[
            {label: t("Considerar o Risco Máximo"),value: "maximum"},
            {label: t("Considerar o Risco Médio"),value: "average"}
        ]

        if(baseDatesOptions.length > 1) options.push({label: t("Selecionar uma Data-Base"),value: "offset_match"})
        return options
    }, [baseDatesOptions, t])

    const [ option, setOption ] = useState(() => {
        const multipleBaseDatesStrategy = nodeState.node.properties?.multiple_dates_bases_strategy
        return multipleBaseDatesStrategy ? multipleBaseDatesOptions.find(opt => opt.value === multipleBaseDatesStrategy) : null
    })
    const [ baseDateOption, setBaseDateOption ] = useState(() => {
        const targetOffset = nodeState.node.properties?.target_offset
        return typeof targetOffset === "number" ? baseDatesOptions.find(opt => opt.value === targetOffset) : null
    })
    const isOptionOffsetMatch = option ? option.value === "offset_match" : false
    const currentStrategy = nodeState.node.properties?.multiple_dates_bases_strategy

    useEffect(() => {
        if(baseDatesOptions.length <= 1 && currentStrategy !== "maximum") {
            handleChange("multiple_dates_bases_strategy", "maximum")
            setOption(multipleBaseDatesOptions.find(opt => opt.value === "maximum"))
        }
    } , [baseDatesOptions, handleChange, multipleBaseDatesOptions, currentStrategy])

    const onMultipleDBStrategyChange = (e, newValue) => {
        e.stopPropagation()
        setOption(newValue)

        const value = newValue.value
        const changeFields = ["multiple_dates_bases_strategy"]
        const changeValues = [value]
        if (value !== "offset_match" && baseDateOption !== null) {
            changeFields.push("target_offset")
            changeValues.push(null)
        }
        handleChange(changeFields, changeValues)
    }

    const onBaseDateOptionChange = (e, newValue) => {
        setBaseDateOption(newValue)
        e.stopPropagation()
        const value = newValue ? newValue.value : null
        handleChange("target_offset", value)
    }

    return (
        <><span className={["blueText", "dialogInfoSize"].join(" ")}>{t("Ao encontrar múltiplas Datas-Bases:")}</span>
        <div style={{
            display: "flex",
            justifyContent: "center",
            width: "100%",
            alignItems: "center",
            marginTop: "10px",
            gap: isOptionOffsetMatch? "10px" : "0px",
            transition: "all 0.3s ease-in-out"
        }}>
            <Autocomplete
                readOnly={readOnly}
                value={option || null}
                getOptionLabel={(option) => t(option.label)}
                isOptionEqualToValue={(option,value) => option.value === value.value}
                onChange={onMultipleDBStrategyChange}
                options={multipleBaseDatesOptions}
                onKeyDown={(e) => {e.preventDefault()}}
                style={{ flex: 6, width: "100%", caretColor: 'transparent' }}
                disableClearable
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label={t("Ação")}
                        readOnly={true}
                        className="filterTextbox"
                        style={{ textAlign: "center" }}
                        error={!!errorState["multiple_dates_bases_strategy"]}
                    />
                )}
            />

            <div style={{
                flex: isOptionOffsetMatch ? 4 : 0,
                opacity: isOptionOffsetMatch ? 1 : 0,
                maxWidth: isOptionOffsetMatch ? "100%" : "0px",
                minWidth: 0,
                overflow: "hidden",
                transition: "all 0.3s ease-in-out",
                whiteSpace: "nowrap"
            }}>
                <Autocomplete
                    readOnly={readOnly}
                    value={baseDateOption || null}
                    getOptionLabel={(option) => t(option.label)}
                    isOptionEqualToValue={(option,value) => option.value === value.value}
                    onChange={onBaseDateOptionChange}
                    options={baseDatesOptions}
                    onKeyDown={(e) => {e.preventDefault()}}
                    style={{ width: "100%", caretColor: 'transparent' }}
                    disableClearable
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label={t("Data-Base")}
                            className="filterTextbox"
                            style={{ textAlign: "center" }}
                            error={!!errorState["target_offset"]}
                            readOnly={true}
                            InputProps={{
                            ...params.InputProps,
                            readOnly: true,
                            endAdornment: (
                                <>
                                    {params.InputProps.endAdornment}
                                    <Tooltip title={
                                        <div className="tooltipText">
                                            <ul>
                                                {
                                                    t("M0 é a data-base mais recente, M1 é a segunda data-base mais recente, e assim por diante.")
                                                }
                                            </ul>
                                        </div>
                                    }>
                                        <HelpIcon style={{ fontSize: "16px", marginLeft: "4px", cursor: "pointer", color: "rgba(0, 0, 0, 0.54)" }}/>
                                    </Tooltip>
                                </>
                            )
                        }}
                        />
                    )}
                />
            </div></div></>
    )
}

function ConsultationDetails(props) {
    const { t } = useTranslation()
    const { readOnly }  = props
    const { nodeState } = props
    const { handleChange } = props

    const [domainType, setDomainType] = useState(() => {
        const savedStart = nodeState.node.properties?.range_start
        const nonExpiringDomain = nodeState.node.properties?.non_expiring_domain

        if (nonExpiringDomain && !savedStart) {
            return domainTypeOptions.find(opt => opt.nonExpiringDomain === nonExpiringDomain) || domainTypeOptions[0]
        } else {
            return domainTypeOptions.find(opt => opt.steps.includes(savedStart)) || domainTypeOptions[0]
        }
    })

    const handleDomainTypeChange = (e, newValue) => {
        setDomainType(newValue)
        let changeFields = []
        let changeValues = []
        if(newValue.label === "Todos") {
            changeFields.push("range_start", "range_end")
            changeValues.push(null, null)
        }
        if(newValue.label !== "Créditos a Vencer") {
            changeFields.push("non_expiring_domain")
            changeValues.push(null)
        }
        handleChange(changeFields, changeValues)
    }

    const handleModalityChange = (newFlatArray) => {
        const groupedModalities = groupModalities(newFlatArray)
        handleChange("modalities", groupedModalities)
    }


    const showSlider = domainType && domainType.label !== "Todos"
    return (
        <div style={{ display: "flex", flexDirection: "column", marginTop: "10px" }}>
            <div style={{ display: "flex", flexDirection: "column", gap: "8px", marginBottom: showSlider? "0px" : "5px" }}>
                <Typography className='blueText' style={{ fontSize: "14px"}}>
                    {t("Informações de Vencimento")}
                </Typography>
                <Autocomplete
                    readOnly={readOnly}
                    options={domainTypeOptions}
                    onChange={handleDomainTypeChange}
                    value={domainType || null}
                    getOptionLabel={(option) => t(option.label)}
                    isOptionEqualToValue={(option, value) => option.label === value.label}
                    disableClearable
                    onKeyDown={(e) => {e.preventDefault()}}
                    style={{ width: "100%", caretColor: 'transparent' }}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label={t("Tipo de Vencimento")}
                            className="filterTextbox"
                            style={{ textAlign: "center" }}
                            error={false}
                            readOnly={true}
                        />
                    )}
                />

                {showSlider && <SCRDurationSlider
                    readOnly={readOnly}
                    domainType={domainType}
                    nodeState={nodeState}
                    handleChange={handleChange}
                />}
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                <Typography className='blueText' style={{ fontSize: "14px"}}>
                    {t("Escolha de Modalidades")}
                </Typography>

                <ModalitySelectionTree
                    readOnly={readOnly}
                    initialSelected={flattenModalities(nodeState.node.properties?.modalities)}
                    onChange={handleModalityChange}
                    data={SCRModalityOptions}
                />
            </div>
        </div>
    )
}

function SCRDurationSlider(props) {
    const { t } = useTranslation()
    const { domainType } = props
    const { nodeState } = props
    const { readOnly } = props
    const { handleChange } = props

    const rangeSectionTitle = domainType.rangeSectionTitle || t("Intervalo de tempo")
    const sliderClasses = useSliderStyles()

    const currentSteps = useMemo(() => {
        const rawSteps = domainType.steps || []
        return [...rawSteps, "inf"]
    }, [domainType])

    const isSliderDisabled = domainType.label === "Todos"
    const isTimeInDays = domainType.label !== "Créditos baixados como prejuízo"
    const range_start = nodeState.node.properties?.range_start
    const range_end = nodeState.node.properties?.range_end
    const non_expiring_domain = nodeState.node.properties?.non_expiring_domain

    const [sliderIndices, setSliderIndices] = useState([0, currentSteps.length - 1])
    const [previousRangesCache, setPreviousRangesCache] = useState({})

    const [includeNonExpiringDomain, setIncludeNonExpiringDomain] = useState(() => {
        return !!non_expiring_domain
    })
    const [onlyNonExpiringDomain, setOnlyNonExpiringDomain] = useState(() => {
        return !range_start && !range_end && !!non_expiring_domain
    })

    useEffect(() => {
        if(domainType.label !== "Créditos a vencer") {
            setIncludeNonExpiringDomain(false)
            setOnlyNonExpiringDomain(false)
            setPreviousRangesCache({})
        }
    }, [domainType])

    const handleNonExpiringChange = (event) => {
        const isChecked = event.target.checked
        setIncludeNonExpiringDomain(isChecked)
        if (isChecked) {
            handleChange("non_expiring_domain", domainType.nonExpiringDomain)
        } else {
            handleChange("non_expiring_domain", null)
        }
    }

    const handleOnlyNonExpiringChange = (event) => {
        const isChecked = event.target.checked
        setOnlyNonExpiringDomain(isChecked)
        if (isChecked) {
            handleNonExpiringChange({target: {checked: true}})
            handleChange(["range_start", "range_end", "non_expiring_domain"], [null, null, domainType.nonExpiringDomain])
            setPreviousRangesCache({
                range_start: range_start,
                range_end: range_end
            })
        } else {
            handleChange(["range_start", "range_end"], [previousRangesCache.range_start, previousRangesCache.range_end])
        }
    }

    useEffect(() => {
        if (isSliderDisabled ||
            onlyNonExpiringDomain) return

        const savedStart = range_start
        const savedEnd = range_end

        let startIndex = currentSteps.indexOf(savedStart)
        let endIndex = currentSteps.indexOf(savedEnd)

        if (endIndex !== -1) endIndex = endIndex + 1
        if (startIndex !== -1 && endIndex !== -1 && endIndex < currentSteps.length && startIndex < endIndex) {
            setSliderIndices([startIndex, endIndex])
        } else {
            setSliderIndices([0, currentSteps.length - 1])
            handleChange(["range_start", "range_end"], [currentSteps[0], currentSteps[currentSteps.length - 2]])
        }
    }, [domainType, isSliderDisabled, range_start, range_end, currentSteps, onlyNonExpiringDomain, handleChange])

    const handleSliderChange = (event, newIndices) => {
        const minDistance = 1

        const activeThumb = (newIndices[0] !== sliderIndices[0]) ? 0 : 1
        if (activeThumb === 0) {
            const clampedStart = Math.min(newIndices[0], sliderIndices[1] - minDistance)
            setSliderIndices([clampedStart, sliderIndices[1]])
        } else {
            const clampedEnd = Math.max(newIndices[1], sliderIndices[0] + minDistance)
            setSliderIndices([sliderIndices[0], clampedEnd])
        }
    }


    const handleSliderChangeCommited = (event, newIndices) => {
        const rangeStart = currentSteps[newIndices[0]]
        const rangeEnd   = currentSteps[newIndices[1] - 1]
        handleChange(["range_start", "range_end"], [rangeStart, rangeEnd])
    }


    const getHumanLabel = (val) => stepToDaysMap[val] || val

    const getThumbValue = (index, type) => {
        if (type === 'start') return currentSteps[index]
        if (type === 'end') return currentSteps[index - 1]
        return 0
    }

    const marks = isSliderDisabled ? [] : currentSteps.map((val, index) => {
        let label = getHumanLabel(val)
        if (index === sliderIndices[0] || index === sliderIndices[1]) {
            label = getHumanLabel(currentSteps[index])
        }
        return { value: index, label: label }
    })

    return (
        <div style={{ opacity: isSliderDisabled ? 0.5 : 1,
                      display: 'flex',
                      flexDirection: 'column',
                      width: '100%' }}>
            <div style={{ display: 'flex',
                          justifyContent: 'space-between',
                          marginBottom: '10px',
                          alignItems: 'flex-start',
                          width: '100%',
                          gap: '8px' }}>
                <div style={{ color: 'rgba(0, 0, 0, 0.6)', flex: 1 }}>
                    {isSliderDisabled
                        ? t("Não é possível selecionar um intervalo sem um tipo de vencimento especificado")
                        : (t(rangeSectionTitle) + (isTimeInDays ? ` (${t("em dias")})` : ` (${t("em meses")})`))
                    }
                </div>
                {domainType.nonExpiringDomain && (
                    <div style={{ display: 'flex', justifyContent: 'space-around', flexDirection: 'column', alignItems: 'flex-start', flex: 1 }}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={includeNonExpiringDomain}
                                    onChange={handleNonExpiringChange}
                                    color="primary"
                                    disabled={readOnly || isSliderDisabled || onlyNonExpiringDomain}
                                    size="small"
                                />
                            }
                            label={
                                <span style={{ fontSize: '0.9rem', color: 'rgba(0, 0, 0, 0.6)' }}>
                                    {t("Incluir créditos sem vencimento")}
                                </span>
                            }
                            style={{ marginRight: 0 }}
                        />
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={onlyNonExpiringDomain}
                                    onChange={handleOnlyNonExpiringChange}
                                    color="primary"
                                    disabled={readOnly || isSliderDisabled}
                                    size="small"
                                />
                            }
                            label={
                                <span style={{ fontSize: '0.9rem', color: 'rgba(0, 0, 0, 0.6)' }}>
                                    {t("Apenas créditos sem vencimento")}
                                </span>
                            }
                            style={{ marginRight: 0 }}
                        />
                    </div>
                )}
            </div>
            <div style={{ padding: '0 10px' }}>
                <Slider
                    classes={{
                        root: sliderClasses.root,
                        markLabel: sliderClasses.markLabel,
                    }}
                    disabled={isSliderDisabled || readOnly || onlyNonExpiringDomain}
                    value={sliderIndices}
                    onChange={handleSliderChange}
                    onChangeCommitted={handleSliderChangeCommited}
                    min={0}
                    max={isSliderDisabled ? 0 : currentSteps.length - 1}
                    step={null}
                    marks={marks}
                    valueLabelDisplay="auto"
                    ValueLabelComponent={ValueLabelComponent}
                    valueLabelFormat={(index) => {
                        const beginIndex = sliderIndices[0]
                        const endIndex = sliderIndices[1]
                        const timeUnit = isTimeInDays ? t("dias") : t("meses")

                        if (beginIndex === 0 && endIndex === currentSteps.length - 1) {
                            return t("Todos os prazos")
                        }
                        if (endIndex === currentSteps.length - 1) {
                            return `${getHumanLabel(getThumbValue(beginIndex, 'start'))}+ ${timeUnit}`
                        } else if (beginIndex === 0) {
                            return `${t("Até")} ${getHumanLabel(getThumbValue(endIndex, 'start'))} ${timeUnit}`
                        } else {
                            return `${getHumanLabel(getThumbValue(beginIndex, 'start'))} ${t("a")} ${getHumanLabel(getThumbValue(endIndex, 'start'))} ${timeUnit}`
                        }
                    }}
                />
            </div>

        </div>
    )
}

function ModalitySelectionTree(props) {
    const { t } = useTranslation()
    const { readOnly } = props
    const { onChange } = props
    const { data } = props
    const { initialSelected } = props

    const [searchTerm, setSearchTerm] = useState("")
    const [selected, setSelected] = useState(initialSelected || [])
    const [expanded, setExpanded] = useState(["01"])

    useEffect(() => {
        setSelected(initialSelected || [])
    }, [initialSelected])

    const filteredData = useMemo(() => {
        if (!searchTerm) return data
        const lowerSearch = searchTerm.toLowerCase()

        return data.map(modality => {
            const modalityMatches = modality.label.toLowerCase().includes(lowerSearch) || modality.value.toLowerCase().includes(lowerSearch)
            const matchingChildren = (modality.submodalities || []).filter(child => {
                return child.label.toLowerCase().includes(lowerSearch) || child.value.toLowerCase().includes(lowerSearch)
            })

            if (modalityMatches) return modality
            if (matchingChildren.length > 0) return { ...modality, submodalities: matchingChildren }
            return null
        }).filter(Boolean)
    }, [data, searchTerm])

    useEffect(() => {
        if (searchTerm) {
            setExpanded(filteredData.map(node => node.value))
        }
    }, [searchTerm, filteredData])

    const handleToggleExpand = (event, nodeIds) => {
        setExpanded(nodeIds)
    }

    const handleCheck = (e, uniqueNodeId, isModality, modalityChildren) => {
        e.stopPropagation()
        if (readOnly) return

        let newSelected

        if (isModality) {
            const parentValue = uniqueNodeId

            const childIds = modalityChildren
                .map(c => `${parentValue}${c.value}`)

            const allSelected = childIds.every(id => selected.includes(id))

            if (allSelected) {
                newSelected = selected.filter(id => !childIds.includes(id))
            } else {
                newSelected = [...new Set([...selected, ...childIds])]
            }
        } else {
            if (selected.includes(uniqueNodeId)) {
                newSelected = selected.filter(id => id !== uniqueNodeId)
            } else {
                newSelected = [...selected, uniqueNodeId]
            }
        }

        setSelected(newSelected)
        onChange(newSelected)
    }

    const handleSelectAll = () => {
        if (readOnly) return
        const allIds = getAllIds(data)
        setSelected(allIds)
        onChange(allIds)
    }

    const handleDeselectAll = () => {
        if (readOnly) return
        setSelected([])
        onChange([])
    }

    return (
        <div style={{ marginTop: 5 }}>
            <TextField
                size="small"
                fullWidth
                placeholder={t("Buscar modalidade...")}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                disabled={readOnly}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <SearchIcon style={{ color: 'rgba(0,0,0,0.54)' }} />
                        </InputAdornment>
                    ),
                }}
                style={{ marginBottom: 5 }}
            />

            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px', marginBottom: '5px' }}>
                <Button
                    size="small"
                    color="primary"
                    onClick={handleSelectAll}
                    disabled={readOnly}
                    style={{ textTransform: 'none', fontSize: '0.75rem', padding: '2px 8px', minWidth: 'auto' }}
                >
                    {t("Selecionar Tudo")}
                </Button>
                <Button
                    size="small"
                    color="secondary"
                    onClick={handleDeselectAll}
                    disabled={readOnly}
                    style={{ textTransform: 'none', fontSize: '0.75rem', padding: '2px 8px', minWidth: 'auto' }}
                >
                    {t("Limpar Seleção")}
                </Button>
            </div>

            <Paper variant="outlined" style={{ height: 300, overflow: 'auto', padding: '5px 0' }}>
                <TreeView
                    defaultCollapseIcon={<ExpandMoreIcon />}
                    defaultExpandIcon={<ChevronRightIcon />}
                    expanded={expanded}
                    onNodeToggle={handleToggleExpand}
                >
                    {filteredData.map(modality => {
                        const parentId = modality.value
                        const children = modality.submodalities || []
                        const childUniqueIds = children.map(c => `${parentId}${c.value}`)
                        const selectedCount = childUniqueIds.filter(id => selected.includes(id)).length
                        const isModalityChecked = selectedCount === childUniqueIds.length && childUniqueIds.length > 0
                        const allChildren = data.find(m => m.value === modality.value)?.submodalities || []
                        const isIndeterminate = selectedCount > 0 && selectedCount < allChildren.length

                        return (
                            <TreeItem
                                key={parentId}
                                nodeId={parentId}
                                label={
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={isModalityChecked}
                                                indeterminate={isIndeterminate}
                                                color="primary"
                                                disabled={readOnly}
                                                onClick={(e) => handleCheck(e, parentId, true, children)}
                                                size="small"
                                                style={{ padding: 4 }}
                                            />
                                        }
                                        label={<Typography style={{ fontSize: '0.9rem', fontWeight: 500 }}>{`${modality.value} - ${t(modality.label)}`}</Typography>}
                                        style={{ margin: 0, width: '100%' }}
                                    />
                                }
                            >
                                {children.map(submodality => {
                                    const uniqueId = `${parentId}${submodality.value}`
                                    return (
                                        <TreeItem
                                            key={uniqueId}
                                            nodeId={uniqueId}
                                            label={
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            checked={selected.includes(uniqueId)}
                                                            color="primary"
                                                            disabled={readOnly}
                                                            onClick={(e) => handleCheck(e, uniqueId, false)}
                                                            size="small"
                                                            style={{ padding: 4 }}
                                                        />
                                                    }
                                                    label={<Typography style={{ fontSize: '0.85rem' }}>{`${submodality.value} - ${t(submodality.label)}`}</Typography>}
                                                    style={{ margin: 0, width: '100%' }}
                                                />
                                            }
                                        />
                                    )
                                })}
                            </TreeItem>
                        )
                    })}
                </TreeView>
                {filteredData.length === 0 && (
                    <div style={{ padding: 20, textAlign: 'center', color: '#999', fontSize: '0.8rem' }}>
                        {t("Nenhuma modalidade encontrada")}
                    </div>
                )}
            </Paper>
        </div>
    )
}

export class SCRBoxClass {
    constructor(rulesContext){
        this.rulesContext = rulesContext
    }
    validate(node){
        let put_error = false
        let alerts = []
        if((node.node.children || []).length !== 0){
            put_error = true
            alerts.push("Este nó não deve possuir filhos")
        }
        if (node.parentNode !== null) {
            if(node.parentNode.on_error){
                put_error = true
                alerts.push("O nó superior está inválido")
            }
        }

        if(!node.node.properties?.multiple_dates_bases_strategy){
            put_error = true
            alerts.push("A ação ao encontrar múltiplas Datas-Bases deve ser especificada")
        }
        return {validated: !put_error, alerts: alerts}
    }

    getType(node){
        return "number"
    }
}
